<template>
  <div class="app-container">
    <el-row :gutter="20">
      <el-col :span="24" :xs="24">
        <el-form :model="queryParams" ref="queryParams" size="small" v-show="showSearch" label-width="120px">
          <el-row :gutter="24">
            <el-col :span="6">
              <el-form-item label="客户名称" prop="compNames">
                <el-input v-model="queryParams.compNames" placeholder="请输入客户名称" clearable @keyup.enter.native="handleQuery" />
                <CustomerDetails v-model="queryParams.compNames" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="使用单位名称" prop="usingUnit">
                <el-input v-model="queryParams.usingUnit" placeholder="请输入使用单位名称" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="小区名称" prop="houseName">
                <el-input v-model="queryParams.houseName" placeholder="请输入小区名称" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="联系人" prop="businessContact">
                <el-input v-model="queryParams.businessContact" placeholder="请输入联系人" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="24">
            <el-col :span="6">
              <!-- <el-form-item label="区域" prop="eqpAreaName">
                <el-select v-model="queryParams.eqpAreaName" placeholder="请选择区域" clearable style="width: 100%;" @change="handleQuery">
                  <el-option label="福州市" value="福州市"></el-option>
                  <el-option label="厦门市" value="厦门市"></el-option>
                  <el-option label="泉州市" value="泉州市"></el-option>
                  <el-option label="漳州市" value="漳州市"></el-option>
                  <el-option label="莆田市" value="莆田市"></el-option>
                  <el-option label="三明市" value="三明市"></el-option>
                  <el-option label="南平市" value="南平市"></el-option>
                  <el-option label="龙岩市" value="龙岩市"></el-option>
                  <el-option label="宁德市" value="宁德市"></el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item label="区域" prop="eqpAreaName">
                <ChinaAreaCascader :multiple="true" :checkStrictly="true" width="100%" v-model="areaSelectedValue" />
              </el-form-item> 
            </el-col>
            <el-col :span="6">
              <el-form-item label="到检年月" prop="inspectionMonthList">
                <el-date-picker v-model="queryParams.inspectionMonthList" type="months" placeholder="请选择到检年月" clearable value-format="yyyy-MM" style="width: 100%;" @change="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="数量" prop="checkedCount">
                <el-input v-model="queryParams.checkedCount" placeholder="请输入数量" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="检测费" prop="testFee">
                <el-input v-model="queryParams.testFee" placeholder="请输入检测费" clearable @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="24">
            <el-col :span="6">
              <el-form-item label="是否收款" prop="isReceipt">
                <el-select v-model="queryParams.isReceipt" placeholder="请选择是否收款" clearable style="width: 100%;" @change="handleQuery">
                  <el-option label="是" value="1"></el-option>
                  <el-option label="否" value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="开票时间" prop="invoiceTimeRange">
                <el-date-picker v-model="queryParams.invoiceTimeRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" clearable
                                style="width: 100%;" @change="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="是否邮寄" prop="isMailing">
                <el-select v-model="queryParams.isMailing" placeholder="请选择是否邮寄" clearable style="width: 100%;" @change="handleQuery">
                  <el-option label="是" value="1"></el-option>
                  <el-option label="否" value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="进度" prop="progress">
                <el-select v-model="queryParams.progress" placeholder="请选择进度" clearable style="width: 100%;" @change="handleQuery">
                  <el-option label="已完成" value="已完成"></el-option>
                  <el-option label="未完成" value="未完成"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <div style="text-align: center;margin-bottom: 10px;">
            <PermissionMethodToolbar :url="url" :id="'toolbar'" @handleSearch="handleQuery" @exportToExcel="exportToExcel" />
          </div>

          <div ref="tableWrap" class="statement-inquiry-table" v-loading="loading" element-loading-text="正在查询数据..." element-loading-spinner="el-icon-loading"
               element-loading-background="rgba(0, 0, 0, 0.5)">
            <el-table ref="dataTable" id="table" :data="tableData" border style="width: 100%; margin-top: 20px"
                      :header-cell-style="{ background: '#d8e8fb', textAlign: 'left', borderColor: '#CCC' }" :height="tableHeight">
              <el-table-column type="index" label="序号" align="center" fixed="left" width="50" :index="indexMethod"></el-table-column>
              <el-table-column label="客户名称" align="left" prop="compName" min-width="160" show-overflow-tooltip fixed="left"></el-table-column>
              <el-table-column label="使用单位名称" align="left" prop="usingUnit" min-width="160" show-overflow-tooltip fixed="left"></el-table-column>
              <el-table-column label="小区名称" align="left" prop="houseName" min-width="140" show-overflow-tooltip></el-table-column>
              <el-table-column label="联系人" align="left" prop="businessContact" min-width="100" show-overflow-tooltip></el-table-column>
              <el-table-column label="区域" align="left" prop="area" min-width="120" show-overflow-tooltip></el-table-column>
              <el-table-column label="到检年月" align="left" prop="inspectionMonth" min-width="100" show-overflow-tooltip></el-table-column>
              <el-table-column label="数量" align="left" prop="checkedCount" min-width="80" show-overflow-tooltip></el-table-column>
              <el-table-column label="未检数量" align="left" prop="uncheckedCount" min-width="90" show-overflow-tooltip></el-table-column>
              <el-table-column label="检测费（折后价）" align="left" prop="testFee" min-width="130" show-overflow-tooltip></el-table-column>
              <el-table-column label="是否收款" align="left" prop="isReceipt" min-width="100" show-overflow-tooltip :formatter="formatYesNo"></el-table-column>
              <el-table-column label="开票时间" align="left" prop="invoiceTime" min-width="120" show-overflow-tooltip :formatter="$tableDateFormatter"></el-table-column>
              <el-table-column label="是否邮寄" align="left" prop="isMailing" min-width="100" show-overflow-tooltip :formatter="formatYesNo"></el-table-column>
              <el-table-column label="进度" align="left" prop="progress" min-width="100" show-overflow-tooltip></el-table-column>
            </el-table>
          </div>

          <el-pagination @size-change="handlePageSizeChange" @current-change="getList" :current-page.sync="queryParams.currPage" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]"
                         :page-size="queryParams.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" />
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { queryReconciliationList, exportReconciliation } from '@/api/contract/contract'
import PermissionMethodToolbar from '@/components/button/PermissionMethodToolbar.vue'
import ChinaAreaCascader from '@/components/ChinaAreaCascader/index.vue';
export default {
  name: 'StatementInquiry',
  props: {
    url: {
      type: String,
      default: ''
    }
  },
  components: {
    PermissionMethodToolbar,
    ChinaAreaCascader
  },
  watch: {
    areaSelectedValue (newVal) {
      this.handleAreaChange(newVal)
    },
  },
  data () {
    return {
      showSearch: true,
      tableHeight: 420,
      tableData: [],
      loading: false,
      total: 0,
      queryParams: {
        currPage: 1,
        pageSize: 200,
        compNames: '',
        usingUnit: '',
        houseName: '',
        businessContact: '',
        eqpAreaName: '',
        inspectionMonthList: [],
        checkedCount: '',
        testFee: '',
        isReceipt: '',
        invoiceTimeRange: [],
        isMailing: '',
        progress: '',
        
      },
      areaSelectedValue: []
    }
  },
  mounted () {
    this.updateTableHeight()
    window.addEventListener('resize', this.handleWindowResize, { passive: true })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleWindowResize)
  },
  methods: {
    handleWindowResize () {
      this.updateTableHeight()
    },
    
    // 处理区域选择变化
    handleAreaChange (value) {
      // ChinaAreaCascader 多选时返回字符串数组，例如 ['福建省/福州市/仓山区/上街镇']
      if (!Array.isArray(value) || value.length === 0) {
        this.queryParams.eqpAreaName = ''
        return
      }
      this.queryParams.eqpAreaName = value.join(',')
    },

    updateTableHeight () {
      this.$nextTick(() => {
        const wrap = this.$refs.tableWrap
        if (!wrap || typeof window === 'undefined') return
        const top = wrap.getBoundingClientRect().top
        const paginationReserve = 56
        const bottomGap = 28
        const spaceBelow = window.innerHeight - Math.max(0, top)
        const h = spaceBelow - paginationReserve - bottomGap
        this.tableHeight = Math.max(240, Math.floor(h))
        this.$nextTick(() => {
          const t = this.$refs.dataTable
          if (t && typeof t.doLayout === 'function') {
            t.doLayout()
          }
        })
      })
    },

    indexMethod (index) {
      return (this.queryParams.currPage - 1) * this.queryParams.pageSize + index + 1
    },

    formatYesNo (row, column, cellValue) {
      if (cellValue === undefined || cellValue === null || cellValue === '') return ''
      const v = String(cellValue)
      if (v === '1' || v === '是') return '是'
      if (v === '0' || v === '否') return '否'
      return v
    },

    handleQuery () {
      this.queryParams.currPage = 1
      this.getList()
    },

    handlePageSizeChange (pageSize) {
      this.queryParams.pageSize = pageSize
      this.queryParams.currPage = 1
      this.getList()
    },

    buildQueryParams () {
      const params = {
        currPage: this.queryParams.currPage,
        pageSize: this.queryParams.pageSize
      }
      if (this.queryParams.compNames) params.compNames = this.queryParams.compNames
      if (this.queryParams.usingUnit) params.usingUnit = this.queryParams.usingUnit
      if (this.queryParams.houseName) params.houseName = this.queryParams.houseName
      if (this.queryParams.businessContact) params.businessContact = this.queryParams.businessContact
      if (this.queryParams.eqpAreaName) params.eqpAreaName = this.queryParams.eqpAreaName
      if (this.queryParams.inspectionMonthList && this.queryParams.inspectionMonthList.length) {
        params.inspectionMonthList = this.queryParams.inspectionMonthList
      }
      if (this.queryParams.checkedCount !== '' && this.queryParams.checkedCount !== null && this.queryParams.checkedCount !== undefined) {
        params.checkedCount = Number(this.queryParams.checkedCount)
      }
      if (this.queryParams.testFee !== '' && this.queryParams.testFee !== null && this.queryParams.testFee !== undefined) {
        params.testFee = this.queryParams.testFee
      }
      if (this.queryParams.isReceipt !== '' && this.queryParams.isReceipt !== null && this.queryParams.isReceipt !== undefined) {
        params.isReceipt = this.queryParams.isReceipt
      }
      if (this.queryParams.invoiceTimeRange && this.queryParams.invoiceTimeRange.length) {
        params.invoiceTimeRange = this.queryParams.invoiceTimeRange
      }
      if (this.queryParams.isMailing !== '' && this.queryParams.isMailing !== null && this.queryParams.isMailing !== undefined) {
        params.isMailing = this.queryParams.isMailing
      }
      if (this.queryParams.progress) params.progress = this.queryParams.progress
      return params
    },

    getList () {
      this.loading = true
      queryReconciliationList(this.buildQueryParams()).then(res => {
        if (res.retCode === 'ok') {
          const records = res.additionalData.records || res.additionalData.list || []
          this.total = res.additionalData.total || 0
          this.tableData = records
          this.loading = false
          this.$nextTick(() => {
            this.updateTableHeight()
          })
        } else {
          this.$message.error(res.retMsg)
          this.loading = false
        }
      }).catch(error => {
        console.error('查询失败:', error)
        this.$message.error('查询失败')
        this.loading = false
      })
    },

    exportToExcel () {
      this.$message.success('正在导出客户对账单数据...')
      exportReconciliation(this.buildQueryParams()).then(response => {
        const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = '客户对账单查询.xlsx'
        link.style.display = 'none'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
        this.$message.success('导出成功')
      }).catch(error => {
        console.error('导出失败:', error)
        this.$message.error('导出失败：' + (error.message || '未知错误'))
      })
    }
  }
}
</script>

<style scoped>
.app-container {
  padding: 20px;
}

.statement-inquiry-table ::v-deep .el-table__fixed,
.statement-inquiry-table ::v-deep .el-table__fixed-right {
  pointer-events: none;
}

.statement-inquiry-table ::v-deep .el-table__fixed *,
.statement-inquiry-table ::v-deep .el-table__fixed-right * {
  pointer-events: auto;
}
</style>
